import * as React from "react";
import * as S from "@styled";
import { RefreshButton } from "components/shared/Button";
import Text from "components/shared/Text";
import { ProcessInstanceBase } from "model/process/ProcessInstance";
import AccordionGroup from "components/shared/AccordionGroup";
import Accordion from "components/shared/Accordion";
import DescriptionList, {
    DescriptionListItem,
} from "components/shared/DescriptionList";
import Time from "shared/Time";
import ContainerWithLoadingSpinner from "components/shared/ContainerWithLoadingSpinner";

interface RunDetailsTableProps {
    processInstances?: ProcessInstanceBase[];
    isLoading: boolean;
    onRefreshButtonClick: () => void;
}

const RunDetailsTable: React.FC<RunDetailsTableProps> = (props) => {
    const [latestExecution, setLatestExecution] =
        React.useState<ProcessInstanceBase>();
    const [restExecutions, setRestExecutions] =
        React.useState<ProcessInstanceBase[]>();

    React.useEffect(() => {
        if (props.processInstances) {
            const processInstanceData = props.processInstances;
            setLatestExecution(processInstanceData[0]);
            setRestExecutions(processInstanceData.slice(1));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.processInstances]);

    return (
        <>
            {(props.isLoading || latestExecution) && (
                <ContainerWithLoadingSpinner loading={props.isLoading}>
                    <S.TemplateWizardResultHistoryTitleContainer>
                        <h3>Result</h3>

                        <RefreshButton
                            onClick={props.onRefreshButtonClick}
                            disabled={props.isLoading}
                        />
                    </S.TemplateWizardResultHistoryTitleContainer>

                    {latestExecution && (
                        <DescriptionList>
                            <div className="two-column-grid">
                                <DescriptionListItem
                                    dt="State"
                                    dd={latestExecution.state}
                                />
                                {latestExecution.exception && (
                                    <DescriptionListItem
                                        dt="Exception"
                                        dd={latestExecution.exception}
                                    />
                                )}
                                <DescriptionListItem
                                    dt="Execution ID"
                                    dd={latestExecution.executionId}
                                />
                                <DescriptionListItem
                                    dt="Start time"
                                    dd={Time.toDetailedLocalTime(
                                        latestExecution.startTimeUtc,
                                    )}
                                />
                                <DescriptionListItem
                                    dt="End time"
                                    dd={Time.toDetailedLocalTime(
                                        latestExecution.endTimeUtc,
                                    )}
                                />
                            </div>
                        </DescriptionList>
                    )}
                </ContainerWithLoadingSpinner>
            )}

            {restExecutions && restExecutions.length > 0 && (
                <S.TemplateWizardResultHistoryContainer>
                    <Text tag="h3">Result history</Text>
                    <AccordionGroup>
                        {restExecutions.map((processInstance, index) => {
                            return (
                                <Accordion key={index}>
                                    <h3 slot="title">
                                        Test result{" "}
                                        {Time.toDetailedLocalTime(
                                            processInstance.startTimeUtc,
                                        )}
                                    </h3>
                                    <DescriptionList>
                                        <div className="two-column-grid">
                                            <DescriptionListItem
                                                dt="State"
                                                dd={processInstance.state}
                                            />
                                            {processInstance.exception && (
                                                <DescriptionListItem
                                                    dt="Exception"
                                                    dd={
                                                        processInstance.exception
                                                    }
                                                />
                                            )}
                                            <DescriptionListItem
                                                dt="Execution ID"
                                                dd={processInstance.executionId}
                                            />
                                            <DescriptionListItem
                                                dt="Start time"
                                                dd={Time.toDetailedLocalTime(
                                                    processInstance.startTimeUtc,
                                                )}
                                            />
                                            <DescriptionListItem
                                                dt="End time"
                                                dd={Time.toDetailedLocalTime(
                                                    processInstance.endTimeUtc,
                                                )}
                                            />
                                        </div>
                                    </DescriptionList>
                                </Accordion>
                            );
                        })}
                    </AccordionGroup>
                </S.TemplateWizardResultHistoryContainer>
            )}
        </>
    );
};

export default RunDetailsTable;
